module.exports = __webpack_public_path__ + "img/ha_pic.87c0209f.png";